export enum ErrorCode {
    UOM_NOT_ALLOWED_FOR_FIELD = "UOM_NOT_ALLOWED_FOR_FIELD",
    UOM_NOT_CONVERTIBLE = "UOM_NOT_CONVERTIBLE"
}

export const ERROR_CODE_I18N_KEYS: Record<ErrorCode, string> = {
    [ErrorCode.UOM_NOT_ALLOWED_FOR_FIELD]: "errors.UOM_NOT_ALLOWED_FOR_FIELD",
    [ErrorCode.UOM_NOT_CONVERTIBLE]: "errors.UOM_NOT_CONVERTIBLE"
};

export const GENERIC_ERROR_I18N_KEY = "errors.GENERIC_ERROR";
